module.exports = __webpack_public_path__ + "media/honey-icons/icon-lock-ed71af33.svg";